import "./bootstrap";
import "./plugins";
import "./app/UnsavedChanges";
import Vue from "vue";
import Vuex from "vuex";
import vuexI18n from "vuex-i18n";
import "./core/coreApp";
import "./app/AppComponents";
import "./app/DemoComponent";
import "./app/SuperAdminComponents";
import "./app/ClientComponents";
import "./app/ScreeningComponent";
import Element from "element-ui";

// import "../sass/formbuilder/main.scss";
import moment from "moment";
import VueSignaturePad from 'vue-signature-pad';
import VueChatScroll from "vue-chat-scroll";
import locale from "element-ui/lib/locale/lang/en";
import storeData from "./store/Index";
import VueHtml2pdf from "vue-html2pdf";
import VueTour from 'vue-tour'
import Vuelidate from 'vuelidate';
import { Plugin } from 'vue-fragment';
import Chart from 'chart.js';

window.Vue = Vue;
window.Chart = Chart;
// vue tour

require('vue-tour/dist/vue-tour.css');
Vue.use(VueTour);


Vue.filter("formatDate", function (value) {
    if (value) {
        return moment(String(value)).format("MM-DD-YYYY");
    }
});

Vue.use(Vuelidate);

Vue.use(Plugin);
// import Vuetify from '../src/plugins/vuetify' // path to vuetify export
// import 'vuetify/dist/vuetify.min.css'
// Vue.use(Vuetify)


Vue.use(VueHtml2pdf);

Vue.use(VueSignaturePad);

Vue.use(VueChatScroll);
/**
 * vuex
 */

Vue.use(Vuex);

Vue.use(Element, {locale});

// import storeData from "./store/Index";
const store = new Vuex.Store(storeData);

// forceupdate component reload and re-render
// Vue.forceUpdate();

/**
 * localization
 * $t('key') or this.$('key')
 * link: https://github.com/dkfbasel/vuex-i18n
 * */

Vue.use(vuexI18n.plugin, store);

// add translations directly to the application
let language = JSON.parse(window.localStorage.getItem("app-languages"));
let key = window.localStorage.getItem("app-language");
Vue.i18n.add(key, language);
// set the start locale to use
Vue.i18n.set(key);

Vue.prototype.$log = console.info;

/*------ localization end ------*/

import firebaseHelper from "./firebase.js";

const app = new Vue({
    store,
    el: "#app",
});

global.app = app;
export default app;
